import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { env } from "../../../../env";
import axiosInstance from "../../../globalInspector/axiosInstance";
import CommonToast from "../../../../components/_utils/CommonToast";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import ICONS from "../../../../assets/Icons";
import { toast } from "react-toastify";

const baseUrl = env.REACT_APP_BASE_URL;

export const ReimburseViewAll = createAsyncThunk(
  "ReimburseViewAll",
  async (values) => {
    const {
      page_no,
      page_size,
      approval_status,
      category,
      bank_account_no,
      search_string,
      ifsc,
      start_date,
      end_date,
      pan,
      entity_id,
      labels,
      recipient_email,
      type,
      associate,
    } = values;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/accounts/reimbursement`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            page_no: page_no,
            page_size: page_size,
            approval_status: associate
              ? associate
              : approval_status && approval_status?.length !== 0
                ? type === "homeDashboard"
                  ? approval_status
                  : [approval_status]
                : type === "homeDashboard"
                  ? []
                  : "",
            category: category,
            search_string: search_string,
            start_date: start_date,
            end_date: end_date,
            entity_id: entity_id,
            bank_account_no: bank_account_no,
            ifsc: ifsc,
            pan: pan,
            labels: labels,
            recipient_email: recipient_email,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
);

export const addNewLabel = createAsyncThunk(
  "addNewLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/reimbursement/add_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      toast.dismiss();

      const existingLabels = JSON?.parse(
        sessionStorage?.getItem("ReimburseAvailableLabels") || [],
      );

      const updatedLabels = Array?.from(
        new Set([...existingLabels, ...labels]),
      );

      const payload = JSON?.stringify(updatedLabels);
      sessionStorage?.setItem("ReimburseAvailableLabels", payload);

      return response?.data;
    } catch (error) {
      if (error?.response?.data?.errors?.base?.[0]) {
        CommonToast({
          text: error?.response?.data?.errors?.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      if (error?.response?.data?.errors?.user_unauthorized?.[0]) {
        CommonToast({
          text: error.response.data.errors.user_unauthorized[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      return rejectWithValue(error);
    }
  },
);

export const removeNewLabel = createAsyncThunk(
  "removeNewLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/reimbursement/remove_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response?.data;
    } catch (error) {
      if (error?.response?.data?.errors?.base) {
        CommonToast({
          text: error.response.data.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      } else {
        CommonToast({
          text: error?.response?.data?.errors?.user_unauthorized[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,

          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }

      return rejectWithValue(error);
    }
  },
);

export const ReimburseRejectAccount = createAsyncThunk(
  "ReimburseRejectAccount",
  async ({ id, AccountIdData }, { rejectWithValue }) => {
    try {
      const data = {
        rejection_reason: AccountIdData,
      };

      const response = await axiosInstance.put(
        `${baseUrl}/accounts/reimbursement/${id}/reject`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          validateStatus: () => true,
        },
      );

      if (response.status === 404) {
        return undefined;
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || null);
    }
  },
);

export const ReimburseApproveAccount = createAsyncThunk(
  "ReimburseApproveAccount",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/reimbursement/${id}/approve`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      if (error?.response?.status === 404) {
        return rejectWithValue(undefined);
      }

      const errData = error?.response?.data || {
        status: false,
        message: "Something went wrong",
      };

      return rejectWithValue(errData);
    }
  },
);

export const viewAccountDetail = createAsyncThunk(
  "viewAccountDetail",
  async (values) => {
    const { id } = values ? values : { id: null };
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/accounts/reimbursement/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
);

export const achivedAccountDetail = createAsyncThunk(
  "achivedAccountDetail",
  async ({ id, Navigate }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("q2p_token");

      const response = await axiosInstance.put(
        `${baseUrl}/accounts/reimbursement/${id}/archive`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": token,
          },
        },
      );

      return response.data;
    } catch (error) {
      if (error?.response?.data?.errors?.user_unauthorized) {
        Navigate("/feature_not_assigned", {
          state: {
            unavailableService: "RAAccountArchive",
          },
        });
        return;
      }

      if (error?.response?.data?.errors?.reimbursement_account) {
        let errorMessage =
          error?.response?.data?.errors?.reimbursement_account?.[0];
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else if (
        error?.response?.data?.errors?.bank_account_number ||
        error?.response?.data?.errors?.permanent_account_number
      ) {
        let errorMessage =
          error?.response?.data?.errors?.bank_account_number[0] ||
          error?.response?.data?.errors?.permanent_account_number[0];
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      let errorMessage =
        error?.response?.data?.errors?.bank_account_number[0] ||
        error?.response?.data?.errors?.reimbursement_account?.[0] ||
        error?.response?.data?.errors?.permanent_account_number[0] ||
        error?.response?.data?.errors[0]?.gstin_detail?.base ||
        error?.response?.data?.errors?.base[0];
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(errorMessage);
    }
  },
);
export const unachivedAccountDetail = createAsyncThunk(
  "unachivedAccountDetail",
  async ({ id, Navigate }, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("q2p_token");

      const response = await axiosInstance.put(
        `${baseUrl}/accounts/reimbursement/${id}/unarchive`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": token,
          },
        },
      );
      return response.data;
    } catch (error) {
      if (error?.response?.data?.errors?.user_unauthorized) {
        Navigate("/feature_not_assigned", {
          state: {
            unavailableService: "RAAccountArchive",
          },
        });
        return;
      }
      const errData = error?.response?.data?.errors;

      if (!errData.base) {
        errData.beneficiary_account.forEach((error3) => {
          if (error?.response?.data.status === false) {
            setTimeout(() => {
              CommonToast({
                text: error3,
                icon: ICONS?.ERROR_WHITE_CIRCLE,
                variant: "var(--error)",
                buttonNeeded: false,
              });
            }, 1000);
          }
        });
      } else {
        CommonToast({
          text: errData.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      return rejectWithValue(errData);
    }
  },
);

export const editReimbursementAccount = createAsyncThunk(
  "editReimbursementAccount",
  async (values, { rejectWithValue }) => {
    const {
      id,
      pan,
      contact_no,
      email,
      gstin,
      category,
      name,
      navigate,
      recipient_email,
      linked_user_id,
    } = values;

    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": sessionStorage.getItem("q2p_token"),
      },
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/reimbursement/${id}/edit_other_details`,
        {
          reimbursement_accounts: {
            pan,
            email,
            contact_no,
            gstin,
            category,
            name,
            recipient_email,
            ...(linked_user_id !== undefined && {
              linked_user_id: linked_user_id || null,
            }),
          },
        },
        requestOptions,
      );

      return response.data;
    } catch (error) {
      let errorMessage;

      if (error.response) {
        if (error.response.data?.errors?.user_unauthorized) {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "RUAccount" },
          });
        }
        errorMessage =
          error.response.data?.errors?.bank_account_number?.[0] ||
          error.response.data?.errors?.reimbursement_account?.[0] ||
          error.response.data?.errors?.permanent_account_number?.[0] ||
          error.response.data?.errors?.[0]?.gstin_detail?.base ||
          error.response.data?.errors?.base?.[0] ||
          error.response.data?.errors?.[0]?.gstin_detail?.base?.[0] ||
          error.response.data.error ||
          (Array.isArray(error.response.data?.errors?.category)
            ? error.response.data?.errors?.category[0]
            : undefined) ||
          "Something went wrong";
      } else {
        errorMessage = error.message;
      }
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(errorMessage);
    }
  },
);

export const createReimburseAccount = createAsyncThunk(
  "createReimbursementAccount",
  async (values, { rejectWithValue }) => {
    const {
      bank_account,
      contact_no,
      email_id,
      gstin,
      ifsc_code,
      panNumber,
      categories,
      navigate,
      account_name,
      labels,
      recipient_email,
      linked_user_id,
      virtual,
    } = values;

    const requestBody = {
      reimbursement_accounts: {
        bank_account_no: bank_account,
        contact_no,
        reimbursement_account: true,
        email: email_id,
        gstin,
        ifsc: ifsc_code,
        pan: panNumber,
        name: account_name,
        labels,
        category:
          categories?.length > GlobalConfiguration.lengthCheckZero
            ? categories
            : null,
        recipient_email,
        linked_user_id,
        virtual,
      },
    };

    try {
      const response = await axiosInstance.post(
        `${baseUrl}/accounts/reimbursement`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      const responseData = error.response?.data;

      if (responseData?.errors?.user_unauthorized) {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "RUAccount" },
        });
        return rejectWithValue("User unauthorized");
      }

      return rejectWithValue(error);
    }
  },
);

export const updateReimbursementAccount = createAsyncThunk(
  "updateReimbursementAccount",

  async (values, { rejectWithValue }) => {
    const { id, bank_account, ifsc_code, name, navigate } = values;

    const requestBody = {
      reimbursement_accounts: {
        name,
        bank_account_no: bank_account,
        ifsc: ifsc_code,
      },
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/reimbursement/${id}`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      const responseData = error.response?.data;
      let errorMessage = "Something went wrong";

      if (responseData?.errors?.user_unauthorized) {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "RUAccount" },
        });
        return rejectWithValue("User unauthorized");
      }

      if (responseData?.errors) {
        const errs = responseData.errors;
        errorMessage =
          errs?.category?.[0] ||
          errs?.bank_account_number?.[0] ||
          errs?.reimbursement_accounts?.[0] ||
          errs?.reimbursement_account?.[0] ||
          errs?.permanent_account_number?.[0] ||
          errs?.[0]?.gstin_detail?.base ||
          errs?.base?.[0] ||
          responseData?.message ||
          error.message;
      } else if (error.response) {
        errorMessage = `HTTP error! status: ${error.response.status}`;
      } else if (error.request) {
        errorMessage = "No response received from the server";
      } else {
        errorMessage = error.message;
      }
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(errorMessage);
    }
  },
);

const ReimburseAccount = createSlice({
  name: "ReimburseAccount",
  initialState: {
    storedPage: 1,
    toggle: false,
    isblur: false,
    ReimburseAccountAvailableLabels: [],

    ReimburseViewAllData: null,
    ReimburseViewAllLoading: null,
    ReimburseViewAllError: null,

    addLabelsLoading: true,
    addLabelsData: [],
    addLabelsError: false,

    removeLabelsLoading: true,
    removeLabelsData: [],
    removeLabelsError: false,

    viewAccountDetailData: null,
    viewAccountDetailLoading: null,
    viewAccountDetailError: null,

    ReimburseRejectData: [],
    ReimburseRejectLoading: true,
    ReimburseRejectError: false,

    ReimburseApproveData: [],
    ReimburseApproveLoading: true,
    ReimburseApproveError: false,

    unachivedDataDetail: null,
    unachivedLoadingDetail: null,
    unachivedErrorDetail: null,

    achivedDataDetail: null,
    achivedLoadingDetail: null,
    achivedErrorDetail: null,

    createReimburse: [],
    isCreateLoading: null,
    isCreateError: null,

    reimbursementAccountEditData: null,
    reimbursementAccountEditError: null,
    reimbursementAccountEditLoading: null,

    reimbursementAccountUpdateData: null,
    reimbursementAccountUpdateError: null,
    reimbursementAccountUpdateLoading: null,
  },
  reducers: {
    setDetailDataToRejectData(state) {
      state.viewAccountDetailData = state.ReimburseRejectData;
    },
    setDetailDataToApprovalData(state) {
      state.viewAccountDetailData = state.ReimburseApproveData;
    },
    resetVerification(state) {
      state.beneVerifyPAN = null;
      state.verifyBank = null;
    },
    setAvailabelLabels: (state, action) => {
      state.ReimburseAccountAvailableLabels = action.payload;
    },
    resetBeneBankData(state) {
      state.beneLookData = null;
    },
    resetPANVerification(state) {
      state.beneVerifyPAN = null;
    },
    resetBankVerification(state) {
      state.verifyBank = null;
    },
    resetBankError(state) {
      state.isBankError = null;
    },
    resetpage: (state) => {
      state.storedPage = 1;
    },
    setStoredPage: (state, action) => {
      state.storedPage = action.payload;
    },
    setToggle: (state, action) => {
      state.toggle = action.payload;
    },

    setIsBlur(state, action) {
      state.isblur = action.payload;
    },

    resetToggle: (state) => {
      state.toggle = false;
    },
    resetViewAllAcc: (state) => {
      state.beneViewAllAccData = null;
      state.beneViewAllAccLoading = null;
      state.beneViewAllAccError = null;
    },
    resetBeneVerifyThisGst: (state) => {
      state.isGSTLoading = null;
      state.beneVerifyGST = null;
      state.isGSTError = null;
    },

    resetLabelLoading: (state) => {
      state.addLabelsLoading = false;
      state.removeLabelsLoading = false;
    },
    resetEditReimbursementAccount: (s) => {
      s.reimbursementAccountEditData = null;
      s.reimbursementAccountEditError = null;
      s.reimbursementAccountEditLoading = null;
    },
    resetUpdateReimbursementAccount: (s) => {
      s.reimbursementAccountUpdateData = null;
      s.reimbursementAccountUpdateError = null;
      s.reimbursementAccountUpdateLoading = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createReimburseAccount.pending, (state) => {
      state.isCreateLoading = true;
    });
    builder.addCase(createReimburseAccount.fulfilled, (state, action) => {
      state.isCreateLoading = false;
      state.createReimburse = action.payload;
      if (action.payload?.errors)
        CommonToast({
          text: action.payload.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
    });
    builder.addCase(createReimburseAccount.rejected, (state, action) => {
      state.isCreateError = true;
    });
    builder.addCase(viewAccountDetail.pending, (state, action) => {
      state.viewAccountDetailLoading = true;
    });
    builder.addCase(viewAccountDetail.fulfilled, (state, action) => {
      state.viewAccountDetailLoading = false;
      state.viewAccountDetailData = action.payload;
    });
    builder.addCase(viewAccountDetail.rejected, (state, action) => {
      state.viewAccountDetailError = true;
      state.viewAccountDetailData = null;
    });

    builder.addCase(addNewLabel.pending, (state, action) => {
      state.addLabelsLoading = true;
    });
    builder.addCase(addNewLabel.fulfilled, (state, action) => {
      state.addLabelsLoading = false;
      state.addLabelsData = action.payload;
    });
    builder.addCase(addNewLabel.rejected, (state, action) => {
      state.addLabelsLoading = false;
      state.addLabelsError = action.payload;
      state.addLabelsData = null;
    });
    builder.addCase(removeNewLabel.pending, (state, action) => {
      state.removeLabelsLoading = true;
    });
    builder.addCase(removeNewLabel.fulfilled, (state, action) => {
      state.removeLabelsLoading = false;
      state.removeLabelsData = action.payload;
    });
    builder.addCase(removeNewLabel.rejected, (state, action) => {
      state.removeLabelsLoading = false;
      state.removeLabelsError = action.payload;
      state.removeLabelsData = null;
    });

    builder.addCase(ReimburseRejectAccount.pending, (state, action) => {
      state.ReimburseRejectLoading = true;
    });
    builder.addCase(ReimburseRejectAccount.fulfilled, (state, action) => {
      state.ReimburseRejectLoading = false;
      state.ReimburseRejectData = action.payload;
    });
    builder.addCase(ReimburseRejectAccount.rejected, (state, action) => {
      state.ReimburseRejectError = true;
      state.ReimburseRejectData = null;
      state.ReimburseRejectLoading = false;
    });
    builder.addCase(ReimburseApproveAccount.pending, (state, action) => {
      state.ReimburseApproveLoading = true;
    });
    builder.addCase(ReimburseApproveAccount.fulfilled, (state, action) => {
      state.ReimburseApproveLoading = false;
      state.ReimburseApproveData = action.payload;
    });
    builder.addCase(ReimburseApproveAccount.rejected, (state, action) => {
      state.ReimburseApproveError = true;
      state.ReimburseApproveData = null;
      state.ReimburseApproveLoading = false;
    });

    builder.addCase(ReimburseViewAll.pending, (state, action) => {
      state.ReimburseViewAllLoading = true;
      if (action?.payload?.summary?.available_labels) {
        state.ReimburseAccountAvailableLabels = [];
      }
    });
    builder.addCase(ReimburseViewAll.fulfilled, (state, action) => {
      state.ReimburseViewAllLoading = false;
      state.ReimburseViewAllData = action.payload;
      state.ReimburseAccountAvailableLabels =
        action?.payload?.summary?.available_labels;
      if (action?.payload?.summary?.available_labels) {
        sessionStorage.setItem(
          "ReimburseAvailableLabels",
          JSON.stringify(action?.payload?.summary?.available_labels || []),
        );
      }
    });
    builder.addCase(ReimburseViewAll.rejected, (state, action) => {
      state.ReimburseViewAllLoading = false;
      state.ReimburseViewAllError = true;
      state.ReimburseViewAllData = null;
      if (action?.payload?.summary?.available_labels) {
        state.ReimburseAccountAvailableLabels = [];
      }
    });
    builder.addCase(unachivedAccountDetail.pending, (state, action) => {
      state.unachivedLoadingDetail = true;
    });
    builder.addCase(unachivedAccountDetail.fulfilled, (state, action) => {
      state.unachivedLoadingDetail = false;
      state.unachivedDataDetail = action.payload;
    });
    builder.addCase(unachivedAccountDetail.rejected, (state, action) => {
      state.unachivedErrorDetail = true;
    });
    builder.addCase(achivedAccountDetail.pending, (state, action) => {
      state.achivedLoadingDetail = true;
    });
    builder.addCase(achivedAccountDetail.fulfilled, (state, action) => {
      state.achivedLoadingDetail = false;
      state.achivedDataDetail = action.payload;
    });
    builder.addCase(achivedAccountDetail.rejected, (state, action) => {
      state.achivedErrorDetail = true;
    });
    builder.addCase(editReimbursementAccount.pending, (state, _) => {
      state.reimbursementAccountEditLoading = true;
      state.reimbursementAccountEditError = null;
    });
    builder.addCase(editReimbursementAccount.fulfilled, (state, action) => {
      state.reimbursementAccountEditLoading = false;
      state.reimbursementAccountEditData = action.payload;
      state.reimbursementAccountEditError = null;
    });
    builder.addCase(editReimbursementAccount.rejected, (state, action) => {
      state.reimbursementAccountEditLoading = false;
      state.reimbursementAccountEditError = action.payload;
      state.reimbursementAccountEditData = null;
    });
    builder.addCase(updateReimbursementAccount.pending, (state, _) => {
      state.reimbursementAccountUpdateLoading = true;
      state.reimbursementAccountUpdateError = null;
    });
    builder.addCase(updateReimbursementAccount.fulfilled, (state, action) => {
      state.reimbursementAccountUpdateLoading = false;
      state.reimbursementAccountUpdateData = action.payload;
      state.reimbursementAccountUpdateError = null;
    });
    builder.addCase(updateReimbursementAccount.rejected, (state, action) => {
      state.reimbursementAccountUpdateLoading = false;
      state.reimbursementAccountUpdateError = true;
      state.reimbursementAccountUpdateData = null;
    });
  },
});
export const {
  resetUpdateReimbursementAccount,
  setDetailDataToRejectData,
  setDetailDataToApprovalData,
  resetVerification,
  resetPANVerification,
  resetBankVerification,
  resetBeneBankData,
  resetBankError,
  resetpage,
  setStoredPage,
  resetToggle,
  setToggle,
  setIsBlur,
  resetViewAllAcc,
  resetLabelLoading,
  resetBeneVerifyThisGst,
  setAvailabelLabels,
  resetEditReimbursementAccount,
} = ReimburseAccount.actions;

export default ReimburseAccount.reducer;
